/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const changeTrialPlanDataTierSchema = z.enum(['lite', 'standard', 'pro', 'premium', 'enterprise', 'service'])

export type ChangeTrialPlanDataTierSchema = z.infer<typeof changeTrialPlanDataTierSchema>
